import { useMemo } from 'react';
import { RichTextRenderer } from '@knack/asterisk-react';

import { sanitizeHTML } from '@/utils/sanitizeHTML';

type SearchInstructionsProps = {
  children: string;
};

export function SearchInstructions({ children }: SearchInstructionsProps) {
  const sanitizedInstruction = useMemo(() => sanitizeHTML(children || ''), [children]);
  return (
    <RichTextRenderer
      dangerouslySetInnerHTML={{ __html: sanitizedInstruction }}
      className="mt-1 text-xs text-gray-500"
    />
  );
}
